import apiRequest from '@libs/apiRequest';
import { call, put } from 'redux-saga/effects';
import { setLoading } from 'utilities/redux.actions';

function formattedEmployeeShiftData({ shifts }) {
    const dayMap = {
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday",
        0: "Sunday"
    };

    let shiftObj = {};
    shifts.forEach(({ shiftName, days }) => {
        days.forEach(day => {
            shiftObj[dayMap[day]] = shiftName;
        });
    });

    return shiftObj;
}

export default function* (action) {
    const {
        meta: { handleSubmit = () => { } },
        payload: { employeeEmail }
    } = action;

    yield put(setLoading(true));

    try {
        const employeeShiftData = yield call(
            apiRequest,
            {
                url: `employee/get-shifts?&filters[employeeEmail]=${employeeEmail}`,
                method: 'get'
            }
        );

        let data = formattedEmployeeShiftData(employeeShiftData.data.data[0]);
        yield put(setLoading(false));
        return handleSubmit({ data });

    } catch (error) {
        yield put(setLoading(false));
    }
}